<div class="list-card-container">
    <finder-anchor *ngIf="card.url; else cardContent" [internal]="internalLink" class="active-link" [href]="card.url">
        <ng-container *ngTemplateOutlet="cardContent"></ng-container>
    </finder-anchor>
    <div class="map-icon" *ngIf="card.marker && isDesktop">
        <finder-font-icon name="maps" size="m"
            (click)="requestFlyToMarker($event)"
            (keydown.enter)="requestFlyToMarker($event)"
            [title]="labels.showOnMap + ': ' + card.name"
            [ariaHidden]="false"
            tabindex="0">
        </finder-font-icon>
    </div>
    <div class="arrow-icon" *ngIf="card.enableArrowIcon">
        <finder-font-icon name="next-2"></finder-font-icon>
    </div>
    <div class="multiple-locations" *ngIf="card.multipleLocations">
        <finder-section
            [expanded]="multipleLocationsConfig.expanded"
            [labels]="multipleLocationsConfig.labels">
            <div class="location" *ngFor="let location of card.multipleLocations.locations">
                <div class="info">
                    <p class="name" *ngIf="location.name">{{ location.name }}</p>
                    <p class="location-name" *ngIf="location.locationName">{{ location.locationName }}</p>
                    <p class="facets" *ngIf="location.facetsLabel">{{ location.facetsLabel }}</p>
                </div>
                <ng-container *ngTemplateOutlet="locationAvailability; context: { $implicit: location }">
                </ng-container>
            </div>
        </finder-section>
    </div>

    <ng-template #cardContent>
        <div class="list-card" #cardElement>
            <div class="content">
                <div class="content-container">
                    <div class="debug" *ngIf="debug">
                        <div class="entity-id">
                            <span>{{card.id}}</span>
                            <finder-font-icon
                                class="clipboard"
                                name="compose-message"
                                size="xs"
                                title="Copy to clipboard"
                                (click)="clipboard($event, card.id)">
                            </finder-font-icon>
                            <div class="clipboard-message" *ngIf="clipboardCopied" @clipboardCopied>
                                Copied to clipboard!
                            </div>
                        </div>
                    </div>
                    <div class="type" *ngIf="card.type">
                        <finder-font-icon class="icon" [name]="type.icon" size="xs"></finder-font-icon>
                        <span>{{type.readback}}</span>
                    </div>
                    <div class="name" [innerHtml]="card.name | safeHtml"></div>
                    <div class="entity-type" *ngIf="options.showEntityType && card.entityTypeName">{{card.entityTypeName}}</div>
                    <div class="facetGroupType" *ngIf="card.facetGroupType">{{ card.facetGroupType }}</div>
                    <div class="location" *ngIf="card.locationName">{{card.locationName}}</div>
                    <div class="facets" *ngIf="card.facetsLabel">{{ card.facetsLabel }}</div>
                    <finder-operating-status [data]="card" [facilityId]="card.id" [labels]="labels"></finder-operating-status>
                    <div class="refurbishment-message" *ngIf="card.closedForRefurbishment">{{ card.closedForRefurbishment }}</div>
                    <div class="single-location" *ngIf="card.singleLocation">
                        <ng-container *ngTemplateOutlet="locationAvailability; context: { $implicit: card.singleLocation }">
                        </ng-container>
                    </div>
                    <div class="schedule-times" *ngIf="options.showOpenHours && card.openHours?.length">
                        <div *ngFor="let openHours of card.openHours" class="operation-hours">
                            <div class="label">
                                <strong>{{openHours.name}}:</strong>
                            </div>
                            <div class="time-range">{{openHours.timeWindow}}</div>
                        </div>
                    </div>
                    <a class="ticketsCta"
                        *ngIf="card.parkTicketsCta?.url"
                        tabindex="0"
                        (keydown.enter)="redirectToTicketsUrl($event, card.parkTicketsCta.url)"
                        (click)="redirectToTicketsUrl($event, card.parkTicketsCta.url)">
                        {{card.parkTicketsCta.text}}
                    </a>
                    <div class="dine-reservation" *ngIf="reservation">
                        <finder-font-icon class="icon" name="dining" size="xs"></finder-font-icon>
                        <div class="reservation-info">
                            <p>{{ reservation.partyCount }}</p>
                            <p>{{ reservation.formattedDateTime }}</p>
                        </div>
                    </div>
                    <div class="published-date" *ngIf="card.publishedDate">
                        <strong>{{card.publishedDate.header}}</strong>
                        {{card.publishedDate.body}}
                    </div>
                    <div class="description" *ngIf="card.description" [innerHtml]="card.description | safeHtml"></div>
                </div>
                <div *ngIf="card?.remyCheckAvailCta" class="remy-cta-container">
                    <finder-font-icon class="remy-cta-icon" size="m" [name]="card.remyCheckAvailCta.icon"></finder-font-icon>
                    <finder-button
                        [href]="card.remyCheckAvailCta.href"
                        [target]="card.remyCheckAvailCta.target"
                        (click)="stopClickPropagation($event)"
                        theme="secondary"
                    >{{card.remyCheckAvailCta.label}}</finder-button>
                </div>
                <div class="disney-premier-access desktop" *ngIf="card.disneyPremierAccess">
                    <finder-premier-access
                        [card]="card"
                        (click)="stopClickPropagation($event)"
                        class="list"
                    ></finder-premier-access>
                </div>
            </div>
            <div class="picture">
                <finder-picture *ngIf="picture" [picture]="picture" class="fit zoom-on-hover"></finder-picture>
            </div>
            <div class="disney-premier-access mobile" *ngIf="card.disneyPremierAccess">
                <finder-premier-access
                    [card]="card"
                    [fullWidth]="true"
                    (click)="stopClickPropagation($event)"
                ></finder-premier-access>
            </div>
        </div>

    </ng-template>

    <ng-template #locationAvailability let-location>
        <div class="location-availability">
            <div class="title" *ngIf="location.title">
                {{ location.title }}
            </div>
            <div class="unavailable-message" *ngIf="location.unavailableReason">
                {{ location.unavailableReason }}
            </div>
            <div class="offers" *ngIf="location.offers">
                <a class="offer"
                    *ngIf="this.isEEC; else timePills"
                    [tabindex]="disablePills ? -1 : 0"
                    [class.disabled]="disablePills"
                    (keydown.enter)="redirectToEECUrl($event)"
                    (click)="redirectToEECUrl($event)">
                    {{ this.labels.eecPillLabel }}
                </a>
                <ng-template #timePills>
                    <a class="offer"
                        *ngFor="let offer of location.offers"
                        [tabindex]="disablePills ? -1 : 0"
                        [class.disabled]="disablePills"
                        (keydown.enter)="redirectToBookingUrl($event, offer)"
                        (click)="redirectToBookingUrl($event, offer)">
                        <span>{{ offer.label }}</span>
                        <finder-loading-spinner class="offer-spinner" *ngIf="offer.validating">
                        </finder-loading-spinner>
                    </a>
                </ng-template>
            </div>
        </div>
    </ng-template>
</div>
